import { all, fork } from 'redux-saga/effects';
import accountsSaga from './accountsSaga';
import cardsSaga from './cardsSaga';
import billingSaga from './billingSaga';
import rolesSaga from './rolesSaga';
import usersSaga from './usersSaga';
import transactionsSaga from './transactionsSaga';
import notificationsSaga from './notificationsSaga';
import storeSaga from './storeSaga';
import invoicesSaga from './invoicesSaga';
import reportsSaga from './reportsSaga';
import maintenanceSaga from './maintenanceSaga';
import accountingIntegrationSaga from './accountingIntegrationSaga';
import everydayRewardsSaga from './everydayRewardsSaga';
import cashSaga from './cashSaga';
import toastAlertSaga from './toastAlertSaga';

export default function* rootSaga() {
  yield all([
    fork(accountsSaga),
    fork(cardsSaga),
    fork(billingSaga),
    fork(rolesSaga),
    fork(usersSaga),
    fork(transactionsSaga),
    fork(notificationsSaga),
    fork(storeSaga),
    fork(invoicesSaga),
    fork(reportsSaga),
    fork(maintenanceSaga),
    fork(accountingIntegrationSaga),
    fork(everydayRewardsSaga),
    fork(cashSaga),
    fork(toastAlertSaga),
  ]);
}
